import { cn } from "@/lib/utils";

/** Bloco de carregamento (skeleton) com animação de pulso. */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn("animate-pulse rounded bg-muted", className)} aria-hidden="true" />;
}
